module.exports = __webpack_public_path__ + "img/logo7.9b3d36e1.png";